import { render, staticRenderFns } from "./WordCould.vue?vue&type=template&id=162bb48a"
import script from "./WordCould.vue?vue&type=script&lang=js"
export * from "./WordCould.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports